import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  country = environment.defaultCountry;
  localStorage
  constructor(@Inject(DOCUMENT) document) {
    this.localStorage = document.defaultView.localStorage;
  }

  getCountry() {
    const host = window.location.host;
    if (host.indexOf("hkuat.singx.co") >= 0 || host.indexOf("hk.singx.co") >= 0) {
      this.redirectToCentralProspect("hk");
    }
    if (host.indexOf("uatau.singx.co") >= 0 || host.indexOf("au.singx.co") >= 0) {
      this.redirectToCentralProspect("au");
    }
    if (host.indexOf("sguat.singx.co") >= 0 || host.indexOf("sg.singx.co") >= 0) {
      this.redirectToCentralProspect("sg");
    }
    const country = this.localStorage.getItem("country");
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (country)
      this.country = country;
    else if (tz.indexOf('Hong') >= 0)
      this.country = 'hk';
    else if (tz.indexOf('Singapore') >= 0)
      this.country = 'sg';
    else if (tz.indexOf('Australia') >= 0)
      this.country = 'au';
    else
      this.country = country;
    this.setCountry(this.country);
    return this.country;
  }

  setCountry(c: string) {
    if (c == 'hk' || c == 'sg' || c == 'au')
      this.country = c;
    else
      this.country = environment.defaultCountry;
    this.localStorage.setItem("country", this.country);
  }

  calcQueryParams() {
    var queryParams = "?";
    queryParams = queryParams + 'country=' + this.country + "&";
    if (localStorage.getItem("utm_source"))
      queryParams = queryParams + "utm_source=" + localStorage.getItem("utm_source") + "&";
    if (localStorage.getItem("utm_campaign"))
      queryParams = queryParams + "utm_campaign=" + localStorage.getItem("utm_campaign") + "&";
    if (localStorage.getItem("utm_term"))
      queryParams = queryParams + "utm_term=" + localStorage.getItem("utm_term") + "&";
    if (localStorage.getItem("utm_medium"))
      queryParams = queryParams + "utm_medium=" + localStorage.getItem("utm_medium") + "&";
    if (localStorage.getItem("utm_content"))
      queryParams = queryParams + "utm_content=" + localStorage.getItem("utm_content") + "&";
    return queryParams;
  }

  redirectToRegistrationPage() {
    let redirectUrl = window.location.href.indexOf('uat') == -1 ? "https://app.singx.co/register" : "https://app-uat.singx.co/register";
    window.location.href = redirectUrl + this.calcQueryParams();
  }

  redirectToLoginPage() {
    let redirectUrl = window.location.href.indexOf('uat') == -1 ? "https://app.singx.co/login" : "https://app-uat.singx.co/login";
    window.location.href = redirectUrl + this.calcQueryParams();
  }

  redirectToCentralProspect(country: string) {
    let redirectUrl = window.location.href.indexOf('uat') == -1 ? "https://singx.co/" : "https://uat.singx.co/";
    window.location.href = redirectUrl + country + this.calcQueryParams() + "&path=" + window.location.pathname;
  }
}